import React, { useEffect } from "react";

export const Modal337 = ({ show, title, text, desc, img, alt, price, onClose }) => {
  //const modalRef = useRef(null);

  useEffect(() => {
    if (show) {
      // Блокируем прокрутку при открытии
      document.body.style.overflow = "hidden";
    } else {
      // Разблокируем прокрутку при закрытии
      document.body.style.overflow = "";
    }

    // Чистим эффект при размонтировании
    return () => {
      document.body.style.overflow = "";
    };
  }, [show]);

  if (!show) return null;

  const handleBackdropClick = (e) => {
    if (e.target.classList.contains("modal")) {
      onClose(); // Закрываем модальное окно, если клик был на бэкдропе
    }
  };

  return (
    <div
      className={`modal fade ${show ? "in" : ""}`}
      style={{
        display: show ? "flex" : "none", // Flexbox для центрирования
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Полупрозрачный фон
        height: "100vh", // Полная высота экрана
      }}
      tabIndex="-1"
      onClick={handleBackdropClick} // Добавляем обработчик клика
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={onClose}>
              &times;
            </button>
            <h4 className="modal-title">{title}</h4>
          </div>
          <div className="modal-body">
            <div className="modal-image">
              <img src={img} alt={alt} />
            </div>
            <p>{desc}</p>
          </div>
          <div className="modal-footer">
            <div className="modal-price">
              <p>{price}</p>
            </div>
            <button className="btn btn-default" onClick={onClose}>
              Закрыть
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};